import moment, { Moment } from "moment";

export default function toLocalTime(timestamp: Date | string): Moment {
  return moment.utc(timestamp).local();
}
